import React, { useContext } from 'react'
import { WHITE } from '../../theme'
import { useStyles } from '../../modules/dossier/components/styles/useStyles'
import { ResponsiveContext } from '../../utils/context/ResponsiveContext'
import { useTheme, Fab as MuiFab } from '@mui/material'

interface AcceptingProps {
	ariaLabel: string,
	onClick: () => void,
	isSelected: boolean,
	label: string,
	fabStyle?: string
	disabled?: boolean
}

type FabProps = AcceptingProps

const Fab: React.FC<FabProps> = (
	{
		ariaLabel,
		onClick,
		isSelected,
		label,
		fabStyle,
		disabled
	}
) => {
	const theme = useTheme()
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes, cx } = useStyles({ isLargeScreen })

	const fabHoverClass = cx(
		{
			[classes.fabHover]: !isSelected
		},
		fabStyle
	)

	return (
		<MuiFab
			disabled={disabled}
			variant="extended"
			color="primary"
			aria-label={ariaLabel}
			onClick={onClick}
			className={fabHoverClass}
			style={
				isSelected ?
					{
						borderRadius: 0,
						color: WHITE,
						background: theme.palette.blue.main
					}
					:
					{
						borderRadius: 0,
						color: theme.palette.blue.main,
						background: theme.palette.blue['5'],
						border: `1px solid ${theme.palette.blue.main}`
					}
			}
		>
			{label}
		</MuiFab>
	)
}

export default Fab
